import { WorkExperience as WorkExperienceType } from 'types/commons';

import { MAX_SIDEBAR_WORK_EXPERIENCE_ITEMS_TO_SHOW } from 'constants/uiSettings';

import styles from './WorkExperience.module.scss';
import WorkExperienceItem from './WorkExperienceItem/WorkExperienceItem';

interface WorkExperienceProps {
  workExperience: WorkExperienceType;
}

const WorkExperience = ({ workExperience }: WorkExperienceProps) => {
  const workExperienceItemsToShow =
    workExperience?.records?.slice(
      0,
      MAX_SIDEBAR_WORK_EXPERIENCE_ITEMS_TO_SHOW
    ) || [];

  return (
    <div className={styles.experienceListWrapper}>
      {workExperienceItemsToShow.map((record, index) => (
        <WorkExperienceItem key={`work-experience-${index}`} record={record} />
      ))}
    </div>
  );
};

export default WorkExperience;
